import i18nConstructor from '@yandex-int/i18n';

import * as keyset from './KhFooter.i18n';

export const i18n = i18nConstructor(keyset);
